import { render, staticRenderFns } from "./ProblemsPanel.vue?vue&type=template&id=a7c0e3e2&scoped=true&"
import script from "./ProblemsPanel.vue?vue&type=script&lang=js&"
export * from "./ProblemsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProblemsPanel.vue?vue&type=style&index=0&id=a7c0e3e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c0e3e2",
  null
  
)

export default component.exports